export function createTurnRepository(config) {
    const { repository, client: api } = config;
    const PREFIX = ['turnCredentials']; // Unique query key prefix
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id, // Include user ID for potential future caching separation
    ];
    return {
        useLookup(context, props, options) {
            const baseQueryKey = getQueryKey(context); // ['turnCredentials', context.principal?.id]
            // Revert to object syntax, ensure queryKey is compatible
            // We don't strictly need the empty `props` in the key here.
            const query = repository.useQuery({
                queryKey: baseQueryKey, // Use the base key derived from context
                queryFn: async () => {
                    // Use the generated SDK method for turnRetrieve
                    const response = await api.turnRetrieve({
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                        },
                    });
                    return response.data;
                },
                ...options, // Spread other options last
            });
            return query;
        },
    };
}
//# sourceMappingURL=assistantTurnRepository.js.map